import { defaultAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_AdvisorWizard = 'Advisor Wizard';
export const AdvisorWizardPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_AdvisorWizard, defaultAccessLevels);
//# sourceMappingURL=advisor-wizard.js.map